// extracted by mini-css-extract-plugin
export var card = "_pt-0";
export var content = "_pt-2";
export var details = "_pt-3";
export var icon = "_pt-1";
export var iconBlue = "_pt-5";
export var iconBrand = "_pt-4";
export var iconGrayBlue = "_pt-6";
export var iconGreen = "_pt-7";
export var iconIndigo = "_pt-8";
export var iconOrange = "_pt-9";
export var iconPurple = "_pt-a";
export var iconRed = "_pt-b";
export var iconWarning = "_pt-c";